import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import api from "@/lib/api";
import ShopHeader from "@/components/app/ShopHeader";
import SareeCard from "@/components/app/SareeCard";
import { Heart } from "lucide-react";
import { getFavorites } from "@/lib/api";

export default function Favorites() {
    const { slug } = useParams();
    const [shop, setShop] = useState(null);
    const [sarees, setSarees] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get(`/shops/${slug}`).then(({ data }) => setShop(data));
        const favs = getFavorites().filter((f) => f.shop_slug === slug);
        if (favs.length === 0) { setSarees([]); setLoading(false); return; }
        Promise.all(favs.map((f) => api.get(`/sarees/${f.id}`).then((r) => r.data.saree).catch(() => null)))
            .then((arr) => setSarees(arr.filter(Boolean)))
            .finally(() => setLoading(false));
    }, [slug]);

    return (
        <div className="min-h-screen bg-brand-beige">
            <ShopHeader shop={shop} slug={slug} back />
            <main className="max-w-5xl mx-auto px-4 sm:px-6 pt-6">
                <div className="ayraa-overline">Your favourites</div>
                <h1 className="font-serif text-3xl sm:text-4xl mt-1.5">Saved sarees</h1>

                {loading ? (
                    <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 sm:gap-6 mt-7">
                        {[1, 2, 3].map((i) => <div key={i} className="aspect-[3/4] rounded-lg skel" />)}
                    </div>
                ) : sarees.length === 0 ? (
                    <div className="ayraa-card p-10 text-center mt-8">
                        <Heart className="w-9 h-9 text-brand-gold mx-auto" strokeWidth={1.2} />
                        <div className="font-serif text-2xl mt-4">No favourites yet</div>
                        <p className="text-brand-muted mt-2">Tap the heart on any saree to save it here.</p>
                        <Link to={`/shop/${slug}`} className="ayraa-btn-primary mt-6 inline-flex">Browse catalog</Link>
                    </div>
                ) : (
                    <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 sm:gap-6 mt-7" data-testid="favorites-grid">
                        {sarees.map((s) => <SareeCard key={s.id} saree={s} shopSlug={slug} />)}
                    </div>
                )}
            </main>
        </div>
    );
}
